export const HeroData = [
  {
    title: "",
    path: "/",
    label: "View Home",
    image: "./assets/images/logo_blackb.jpg",
    alt: "darkalogo",
  },
];
